// export const accountsUrl=`https://good-plum-dragonfly-coat.cyclic.app/accounts`
export const productsUrl=`https://good-plum-dragonfly-coat.cyclic.app/products`

// export const accountsUrl=`http://localhost:8001/accounts`
// export const productsUrl=`http://localhost:8001/products`

export const accountsUrl=`https://bohemianclone-server.onrender.com/accounts`
// export const productsUrl=`https://bohemianclone-server.onrender.com/products`